import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as profileActions from "../../redux/actions/profileAction";
import { useSelector, useDispatch } from "react-redux";
import PrefferedLanguage from "../../components/Settings/PrefferedLanguage";
import PropTypes from "prop-types";
import LastLoginDetailComponent from "../../components/LastLoginDetails";

const LastLoginDetails = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);
  const profileAction = bindActionCreators(profileActions, dispatch);

  ///Call api after first render
  useEffect(() => {
    profileAction.getLastLoginInfo(profileReducer);
  }, []);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  // Close modal component on change component
  useEffect(() => {
    return () => {
      closeRemoveModal();
    };
  }, []);

  return (
    <LastLoginDetailComponent
      context={context}
      closeRemoveModal={closeRemoveModal}
      {...props}
      lastLoginDetails={profileReducer.lastLoginDetails}
    />
  );
};

LastLoginDetails.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default LastLoginDetails;
